module.exports = __webpack_public_path__ + "img/2.5e6a7d6e.jpg";